import {Link} from "react-router-dom";
import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";
import BlockLinkWithImg from "./BlockLinkWithImg";

export default () => {
    const title = 'Виды туризма';

    const listTypes = [
        {
            imgFile: require('./img/typeoftourism/automototourism.jpg'),
            toLink: '/auto_moto_tourism',
            sub: 'Автомото туризм'
        },
        {
            imgFile: require('./img/typeoftourism/cyclingtourism.jpg'),
            toLink: '/cycling_tourism',
            sub: 'Велосипедный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/domestictourism.jpg'),
            toLink: '/domestic_tourism',
            sub: 'Внутренний туризм'
        },
        {
            imgFile: require('./img/typeoftourism/watertourism.jpg'),
            toLink: '/water_tourism',
            sub: 'Водный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/inboundtourism.jpg'),
            toLink: '/inbound_tourism',
            sub: 'Въездной туризм'
        },
        {
            imgFile: require('./img/typeoftourism/outboundtourism.jpg'),
            toLink: '/outbound_tourism',
            sub: 'Выездной туризм'
        },
        {
            imgFile: require('./img/typeoftourism/businesstourism.jpg'),
            toLink: '/business_tourism',
            sub: 'Деловой туризм'
        },
        {
            imgFile: require('./img/typeoftourism/disabledtourism.jpg'),
            toLink: '/disabled_tourism',
            sub: 'Инвалидный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/commercialtourism.jpg'),
            toLink: '/commercial_tourism',
            sub: 'Коммерческий туризм'
        },
        {
            imgFile: require('./img/typeoftourism/equestriantourism.jpg'),
            toLink: '/equestrian_tourism',
            sub: 'Конный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/culturaltourism.jpg'),
            toLink: '/cultural_tourism',
            sub: 'Культурный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/medicaltourism.jpg'),
            toLink: '/medical_tourism',
            sub: 'Лечебно оздоровительный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/skitourism.jpg'),
            toLink: '/ski_tourism',
            sub: 'Лыжный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/youthtourism.jpg'),
            toLink: '/youth_tourism',
            sub: 'Молодежный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/museumtourism.jpg'),
            toLink: '/museum_tourism',
            sub: 'Музейный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/scientifictourism.jpg'),
            toLink: '/scientific_tourism',
            sub: 'Научный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/nostalgictourism.jpg'),
            toLink: '/nostalgic_tourism',
            sub: 'Ностальгический (этнический) туризм'
        },
        {
            imgFile: require('./img/typeoftourism/huntingtourism.jpg'),
            toLink: '/hunting_tourism',
            sub: 'Охотничный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/pilgrimagetourism.jpg'),
            toLink: '/pilgrimage_tourism',
            sub: 'Паломнический туризм'
        },
        {
            imgFile: require('./img/typeoftourism/hiking.jpg'),
            toLink: '/hiking',
            sub: 'Пешеходный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/bordertourism.jpg'),
            toLink: '/border_tourism',
            sub: 'Приграничный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/adventuretourism.jpg'),
            toLink: '/adventure_tourism',
            sub: 'Приключенческий туризм'
        },
        {
            imgFile: require('./img/typeoftourism/recreationaltourism.jpg'),
            toLink: '/recreational_tourism',
            sub: 'Рекреационный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/amateurtourism.jpg'),
            toLink: '/amateur_tourism',
            sub: 'Самодеятельный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/weddingtourism.jpg'),
            toLink: '/wedding_tourism',
            sub: 'Свадебный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/ruraltourism.jpg'),
            toLink: '/rural_tourism',
            sub: 'Сельский туризм'
        },
        {
            imgFile: require('./img/typeoftourism/sportstourism.jpg'),
            toLink: '/sports_tourism',
            sub: 'Спортивный туризм'
        },
        {
            imgFile: require('./img/typeoftourism/ecotourism.jpg'),
            toLink: '/ecotourism',
            sub: 'Экологический туризм (экотуризм)'
        },
    ];

    let viewListTypes = listTypes.map((item, index) => {
            return (
                <BlockLinkWithImg
                    key = {index}
                    toLink = {item.toLink}
                    imgFile = {item.imgFile}
                    sub = {item.sub}
                />
            );
        }
    );

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {viewListTypes}
                </div>
            </div>
        </>
    );
}